import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CollectionTableModule } from '@component/collection-table';
import { EntityCardComponent } from './entity-card.component';

@NgModule({
  declarations: [EntityCardComponent],
  exports: [EntityCardComponent],
  imports: [
    CollectionTableModule,
    CommonModule,
    InlineSVGModule,
    MatMenuModule,
    MatTooltipModule,
    RouterModule
  ]
})
export class EntityCardModule {}
